<template>
  <div class="purchase-item-model-edit-form flex flex-col">
    <div class="primary-lighten-1 flex w-full flex-col gap-y-2 rounded-md p-2">
      <div>
        <label>
          <span class="sr-only block text-sm">Artikelnaam</span>
          <InputText
            v-model="rentalDispenseItem.name"
            ref="inputName"
            placeholder="Artikelnaam"
            :errors="v$.name.$errors"
            @focusout="v$.name.$touch()"
          />
        </label>
      </div>
      <div>
        <label>
          <span class="sr-only block text-sm">Eenheid</span>
          <UnitCombobox
            v-model="rentalDispenseItem.unit"
            input-placeholder="Eenheid"
            grow
            :errors="v$.unit.$errors"
            @focusout="v$.unit.$touch()"
            :disabled="true"
          />
        </label>
      </div>

      <ModelEditFormProjectRentalDispenseItem
        v-if="creationParameters?.project"
        :project="creationParameters.project"
        :rental-dispense-item="rentalDispenseItem"
        ref="modelEditFormProjectRentalDispenseItem"
      />

      <ModelEditFormKnownBusinessEntityRentalDispenseItem
        v-if="creationParameters?.project"
        :project="creationParameters.project"
        :rental-dispense-item="rentalDispenseItem"
        ref="modelEditFormKnownBusinessEntityRentalDispenseItem"
      />

      <div>
        <label>
          <span class="block text-sm">Eenheidsprijs per dag</span>
          <InputNumber
            v-model="rentalDispenseItem.unitPricePerDay"
            placeholder="Eenheidsprijs per dag"
            allow-zero
          >
            <span class="sm:text-sm">&euro;</span>
          </InputNumber>
        </label>
      </div>
    </div>
    <FormValidationAlert v-model="v$" />
  </div>
</template>

<script setup lang="ts">
import { inject, onMounted, ref } from "vue"
import { RentalDispenseItem } from "@/models/rental-dispense-item.model.js"
import { requiredValidator } from "@/helper/validation/validators.js"
import InputText from "@/components/inputs/InputText.vue"
import InputNumber from "@/components/inputs/InputNumber.vue"
import { upperFirst } from "lodash-es"
import type { RentalDispenseItemController } from "@/controllers/rental-dispense-item-controller.ts"
import { useFormConfigurator } from "@/composables/form/form-configurator"
import { formFocusHack } from "@/helper/form-helper"
import UnitCombobox from "@/components/inputs/UnitCombobox.vue"
import { Units } from "@/enums/units.enum"
import { Project } from "@/models/project.model"
import ModelEditFormProjectRentalDispenseItem from "@/components/administrative_item/ModelEditFormProjectRentalDispenseItem.vue"
import ModelEditFormKnownBusinessEntityRentalDispenseItem from "@/components/administrative_item/ModelEditFormKnownBusinessEntityRentalDispenseItem.vue"
import FormValidationAlert from "@/components/validation/FormValidationAlert.vue"
import { uniqueRentalDispenseItemValidator } from "@/helper/validation/rental-dispense-item-validation.ts"

const inputName = ref()

const rules = {
  name: { requiredValidator },
  unit: { requiredValidator },
  $validator: uniqueRentalDispenseItemValidator
}

const controller: RentalDispenseItemController = inject("rentalDispenseItemController")!

const {
  model: rentalDispenseItem,
  initialText,
  v$
} = useFormConfigurator<RentalDispenseItem>({
  controller,
  rules,
  customSaveHandler
})

const creationParameters: { project?: Project } = inject("creationParameters")!

onMounted(() => {
  if (initialText) {
    rentalDispenseItem.value.name = upperFirst(initialText)
  }
  formFocusHack(inputName, rentalDispenseItem, "name")

  rentalDispenseItem.value.unit = Units.PIECE
})

const modelEditFormProjectRentalDispenseItem = ref()
const modelEditFormKnownBusinessEntityRentalDispenseItem = ref()
async function customSaveHandler(save: () => Promise<void>) {
  await save()
  if (creationParameters.project) {
    await modelEditFormProjectRentalDispenseItem.value.savePriceAgreement()
    await modelEditFormKnownBusinessEntityRentalDispenseItem.value.savePriceAgreement()
  }
}
</script>

<style scoped></style>
